import { type BaseKitchenScreenRepository } from "../../_Bases/BaseKitchenScreenRepository";
import { type LocalKitchenScreen } from "../../_Bases/BaseKitchenScreenRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBKitchenScreenRepository extends BaseIndexedDBRepository<
    LocalKitchenScreen
> implements BaseKitchenScreenRepository {
    public readonly source: InternalIndexedDBDatabase["kitchenScreens"];
    protected readonly dataTypeName = "Kitchen Screen";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.kitchenScreens;
    }
}
